import React from "react";
import seller from "./seller";

const wrap = { maxWidth: 760, margin: "0 auto", padding: "24px 16px 64px", lineHeight: 1.6, fontSize: 16 };

const Offer = () => (
  <div style={wrap}>
    <h1>Публичная оферта о предоставлении доступа к сервису «СпросиPRO»</h1>
    <p>Редакция от {seller.updated}</p>

    <h2>1. Общие положения</h2>
    <p>
      1.1. Настоящий документ является официальным публичным предложением (офертой) {seller.genitive} (далее — «Исполнитель»)
      заключить договор возмездного оказания услуг на изложенных ниже условиях с любым дееспособным физическим лицом,
      достигшим 18 лет (далее — «Пользователь»).
    </p>
    <p>1.2. Оферта размещена по адресу https://sprosi.link/offer и действует до её отзыва или замены Исполнителем.</p>
    <p>
      1.3. Акцептом оферты (п. 3 ст. 438 ГК РФ) является оплата Пользователем стоимости услуги через платёжную форму в
      Приложении или на Сайте. С момента акцепта договор считается заключённым в письменной форме (п. 2 ст. 434 ГК РФ) на
      условиях настоящей оферты.
    </p>
    <p>
      1.4. Исполнитель вправе изменять оферту. Новая редакция вступает в силу с момента публикации на Сайте и применяется
      к расчётным периодам, начинающимся после публикации. Действующая редакция всегда доступна по адресу выше.
    </p>

    <h2>2. Термины</h2>
    <p>
      <b>Приложение</b> — мобильное приложение «Спроси» для iOS и Android.<br />
      <b>Сайт</b> — https://sprosi.link и его поддомены.<br />
      <b>Услуга («СпросиPRO»)</b> — предоставление Пользователю доступа к дополнительным функциям Приложения,
      описанным в разделе 3.<br />
      <b>Подписка</b> — предоставление доступа к Услуге на повторяющиеся расчётные периоды с автоматической оплатой.<br />
      <b>Расчётный период</b> — 7 (семь) календарных дней с момента подтверждения оплаты.
    </p>

    <h2>3. Предмет договора</h2>
    <p>
      3.1. Исполнитель предоставляет Пользователю доступ к дополнительным функциям Приложения «СпросиPRO»: к техническим
      сведениям об отправителе анонимного вопроса, которые Приложение определяет автоматически, — предполагаемый город,
      тип устройства и браузер отправителя.
    </p>
    <p>
      3.2. Услуга оказывается дистанционно. Доступ открывается автоматически после подтверждения оплаты платёжным
      сервисом, как правило в течение нескольких минут. Отдельная передача материальных носителей и доставка не
      производятся.
    </p>
    <p>
      3.3. Сведения, указанные в п. 3.1, носят информационный и вероятностный характер: они определяются автоматически по
      техническим данным соединения (IP-адрес, сведения браузера) и <b>не позволяют установить личность отправителя</b>.
      Исполнитель не гарантирует их точность и не предоставляет персональные данные третьих лиц.
    </p>
    <p>
      3.4. Услуга считается оказанной надлежащим образом за каждый расчётный период, в течение которого Пользователю был
      открыт доступ к функциям «СпросиPRO», независимо от интенсивности их использования.
    </p>

    <h2>4. Стоимость услуги и порядок оплаты</h2>
    <p>4.1. Стоимость Услуги составляет 999 (девятьсот девяносто девять) рублей за один расчётный период — 7 дней. {seller.tax}.</p>
    <p>
      4.2. Оплата производится банковской картой через платёжный сервис ЮKassa. Данные банковской карты вводятся на
      защищённой странице платёжного сервиса; Исполнитель не получает, не обрабатывает и не хранит реквизиты карты.
    </p>
    <p>4.3. Первый расчётный период начинается с момента подтверждения платежа платёжным сервисом.</p>
    <p>
      4.4. Оформляя Подписку, Пользователь даёт согласие на периодические автоматические списания указанной в п. 4.1
      суммы с привязанной банковской карты — по одному списанию за расчётный период, примерно за час до окончания
      оплаченного периода, до момента отмены Подписки Пользователем.
    </p>
    <p>
      4.5. Если списание не прошло (недостаточно средств, ограничения банка и т. п.), Исполнитель повторяет попытку не
      более 3 (трёх) раз с интервалом около 24 часов. После третьей неуспешной попытки автопродление отключается, а
      доступ к Услуге прекращается по окончании оплаченного периода.
    </p>
    <p>4.6. Все расчёты производятся в рублях Российской Федерации.</p>

    <h2>5. Отмена подписки</h2>
    <p>
      5.1. Пользователь вправе отказаться от Подписки в любой момент: в Приложении — «Настройки» → «Управление
      подпиской» → отключить автопродление, либо направив заявление на {seller.email}.
    </p>
    <p>
      5.2. Отмена прекращает дальнейшие списания. Доступ к Услуге сохраняется до окончания оплаченного расчётного
      периода.
    </p>
    <p>5.3. Удаление Приложения само по себе не отменяет Подписку — необходимо отключить автопродление способом из п. 5.1.</p>

    <h2>6. Возврат денежных средств</h2>
    <p>
      6.1. Если доступ к Услуге не был предоставлен по вине Исполнителя (техническая ошибка, сбой, двойное списание),
      уплаченная сумма возвращается Пользователю в полном объёме.
    </p>
    <p>
      6.2. Денежные средства, списанные ошибочно, в том числе после отмены Подписки, возвращаются в полном объёме.
    </p>
    <p>
      6.3. За расчётный период, в течение которого доступ к Услуге был фактически предоставлен, оплата возврату не
      подлежит, поскольку Услуга считается оказанной (п. 3.4).
    </p>
    <p>
      6.4. Для возврата Пользователь направляет заявление на {seller.email} с указанием даты и суммы платежа,
      идентификатора платежа либо последних четырёх цифр карты и причины обращения. Заявление рассматривается в течение
      10 (десяти) календарных дней со дня получения (ст. 31 Закона РФ «О защите прав потребителей»).
    </p>
    <p>
      6.5. Возврат производится тем же способом, которым была произведена оплата, — на ту же банковскую карту. Срок
      зачисления средств зависит от банка-эмитента и составляет, как правило, до 10 рабочих дней с момента возврата.
    </p>

    <h2>7. Права и обязанности сторон</h2>
    <p>
      7.1. Исполнитель обязуется предоставить доступ к Услуге после оплаты, обеспечивать работоспособность Приложения и
      рассматривать обращения Пользователя.
    </p>
    <p>
      7.2. Исполнитель вправе проводить технические работы с временным приостановлением доступа, а также отказать в
      оказании Услуги и расторгнуть договор при нарушении Пользователем Условий использования приложения
      (https://sprosi.link/terms), вернув оплату за неиспользованные оплаченные дни.
    </p>
    <p>
      7.3. Пользователь обязуется предоставлять достоверные данные при оплате, самостоятельно обеспечивать доступ в
      интернет и исправность своего устройства, не использовать Услугу в целях, нарушающих законодательство Российской
      Федерации.
    </p>

    <h2>8. Ответственность</h2>
    <p>
      8.1. Ответственность Исполнителя ограничена стоимостью Услуги, оплаченной Пользователем за расчётный период, в
      котором возникли основания для ответственности.
    </p>
    <p>
      8.2. Исполнитель не несёт ответственности за содержание анонимных вопросов, отправляемых третьими лицами, за
      действия платёжных систем и операторов связи, а также за невозможность использования Услуги по причинам, не
      зависящим от Исполнителя.
    </p>
    <p>
      8.3. Стороны освобождаются от ответственности за неисполнение обязательств вследствие обстоятельств непреодолимой
      силы.
    </p>

    <h2>9. Персональные данные</h2>
    <p>
      9.1. Обработка персональных данных осуществляется в соответствии с Федеральным законом № 152-ФЗ «О персональных
      данных» и Политикой конфиденциальности: https://sprosi.link/policy. Акцептуя оферту, Пользователь даёт согласие на
      обработку своих данных в объёме, необходимом для оказания Услуги и проведения расчётов.
    </p>

    <h2>10. Срок действия и разрешение споров</h2>
    <p>10.1. Договор действует с момента акцепта до исполнения сторонами обязательств или до отмены Подписки.</p>
    <p>
      10.2. Все споры решаются путём переговоров. Претензионный порядок обязателен: срок ответа на претензию — 10 (десять)
      календарных дней с момента получения. Неурегулированные споры рассматриваются в суде в соответствии с
      законодательством Российской Федерации, включая Закон РФ «О защите прав потребителей».
    </p>

    <h2>11. Реквизиты Исполнителя</h2>
    <p>
      {seller.name}<br />
      ИНН: {seller.inn}<br />
      ОГРНИП: {seller.ogrnip}<br />
      Адрес: {seller.address}<br />
      Электронная почта: {seller.email}<br />
      Служба поддержки: {seller.telegram}
    </p>
  </div>
);

export default Offer;
